import {
  useProduct,
  useSelectedVariant,
  useSelectionActions
} from '@/components/product/product-context';
import { getMatchingVariant } from '@/components/product/utils/get-matching-variant';

/**
 * The click handler shared by both column selectors: swap the selected variant
 * for the one matching `optionValue`.
 *
 * Reads the selected variant and the selection actions, so it can only be
 * called inside a Suspense boundary.
 */
export function useColumnOptionClick() {
  const { productData } = useProduct();
  const { variant } = useSelectedVariant();
  const { updateOption } = useSelectionActions();

  return (optionValue) => {
    if (!variant || !productData) {
      console.warn(
        '[ColumnSelector] No variant or product data found in state'
      );
      return;
    }

    try {
      const newVariant = getMatchingVariant(productData, variant, optionValue);
      if (updateOption && newVariant?.selectedOptions) {
        updateOption(newVariant.selectedOptions);
      }
    } catch (error) {
      console.error('[ColumnSelector]:', error);
    }
  };
}
